import {
  ArrowRightOutlined,
  MedicineBoxOutlined,
  ShopOutlined,
  TeamOutlined
} from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getOverviewMetrics } from '../../api/customerCareDashboard';
import './style.less';

export default function CareHome() {
  const token = useSelector((state) => state.auth.token);
  const [metrics, setMetrics] = useState({
    doctorsCount: 0,
    patientsCount: 0,
    pharmaciesCount: 0,
  });

  useEffect(() => {
    if (!token) return;
    getOverviewMetrics(token).then(setMetrics);
  }, [token]);

  const cards = [
    {
      to: '/doctors',
      title: 'Doctor profiles',
      value: metrics.doctorsCount,
      desc: 'Clinical providers currently listed in doctor_profile.',
      icon: <MedicineBoxOutlined />,
      tone: 'doctors'
    },
    {
      to: '/patients',
      title: 'Patient profiles',
      value: metrics.patientsCount,
      desc: 'Patient records available for care tracking and support.',
      icon: <TeamOutlined />,
      tone: 'patients'
    },
    {
      to: '/pharmacy',
      title: 'Pharmacy profiles',
      value: metrics.pharmaciesCount,
      desc: 'Connected pharmacy partners and store configuration.',
      icon: <ShopOutlined />,
      tone: 'pharmacy'
    },
  ];

  return (
    <div className="care-page">
      <div className="care-data-panel">
        <div className="care-overview-shell">
          <ul className="care-overview-grid" aria-label="Overview metrics">
            {cards.map((card) => (
              <li key={card.title}>
                <Link to={card.to} className={`care-overview-card care-overview-card--${card.tone}`}>
                  <div className="care-overview-card-top">
                    <span className="care-overview-card-icon" aria-hidden>
                      {card.icon}
                    </span>
                    <span className="care-overview-card-kicker">{card.title}</span>
                  </div>

                  <strong className="care-overview-card-value">{card.value}</strong>
                  <span className="care-overview-card-desc">{card.desc}</span>

                  <span className="care-overview-card-link">
                    Open section <ArrowRightOutlined />
                  </span>
                </Link>
              </li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
}
